<template>
  <nav class="sidebar sidebar-offcanvas" id="sidebar">
    <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
      <a class="navbar-brand brand-logo" :href="logoUrl">
        <img :src="logoSrc" alt="logo"/>
      </a>
      <a class="navbar-brand brand-logo-mini" :href="logoUrl">
        <img :src="logoIconSrc" alt="logo"/>
      </a>
    </div>

    <app-punch-timer/>
    <app-global-punch-in/>

    <ul class="nav nav-scrolling">

      <template v-for="(item, index) in data" :key="index">
      <li class="nav-item"
          v-if="item.permission"
          :class="{ 'has-submenu': !!item.subMenu, 'is-open': openIndex === index }"
          @mouseenter="onEnter(index, $event)"
          @mouseleave="onLeave(index)">
        <a class="nav-link"
           :href="item.subMenu ? 'javascript:void(0)' : item.url"
           @click="item.subMenu ? toggle(index, $event) : null">
                    <span class="icon-wrapper">
                        <app-icon :name="item.icon" class="menu-icon"/>
                    </span>
          <span class="menu-title">{{ item.name }}</span>
          <i v-if="item.subMenu" class="menu-arrow"/>
        </a>

        <div class="submenu-flyout"
             v-if="item.subMenu"
             :class="{ 'is-hover': hoverIndex === index }"
             :style="flyoutStyle(index)">
          <div class="submenu-flyout__title">{{ item.name }}</div>
          <ul class="submenu-flyout__list">
            <template v-for="(submenuItem, si) in item.subMenu" :key="si">
            <li v-if="submenuItem.permission === true || submenuItem.permission === ''">
              <a class="submenu-flyout__link"
                 :class="{ active: isActive(submenuItem.url) }"
                 :href="submenuItem.url">
                {{ submenuItem.name }}
              </a>
            </li>
            </template>
          </ul>
        </div>
      </li>
      </template>
    </ul>
  </nav>
</template>

<script>
import AppFunction from "../../helpers/app/AppFunction";

export default {
  name: "Sidebar",
  props: {
    data: {
      type: Array,
      required: true
    },
    logoSrc: {
      type: String,
      default: AppFunction.getAppUrl('images/core.png'),
    },
    logoIconSrc: {
      type: String,
      default: AppFunction.getAppUrl('images/core.png'),
    },
    logoUrl: {
      type: String,
      default: '/'
    }
  },
  data() {
    return {
      openIndex: null,   // mobile: which submenu is tapped open
      hoverIndex: null,  // desktop: which fly-out is hovered
      flyTop: 0,
      flyLeft: 0,
    }
  },
  methods: {
    isDesktop() {
      return window.innerWidth >= 992;
    },
    // Desktop hover: position the fly-out as a fixed panel next to the sidebar
    // (fixed escapes the sidebar's overflow:hidden clipping).
    onEnter(index, ev) {
      if (!this.isDesktop()) return;
      const li = ev.currentTarget;
      const rect = li.getBoundingClientRect();
      const sidebar = document.getElementById('sidebar');
      const right = sidebar ? sidebar.getBoundingClientRect().right : rect.right;
      this.flyTop = Math.max(8, rect.top);
      this.flyLeft = right;
      this.hoverIndex = index;
    },
    onLeave(index) {
      if (this.hoverIndex === index) this.hoverIndex = null;
      if (this.openIndex === index) this.openIndex = null;
    },
    // Mobile/touch: tap a parent to expand/collapse its submenu inline.
    toggle(index, ev) {
      if (this.isDesktop()) return; // desktop uses hover
      if (ev) ev.preventDefault();
      this.openIndex = this.openIndex === index ? null : index;
    },
    flyoutStyle(index) {
      return this.hoverIndex === index
        ? { top: this.flyTop + 'px', left: this.flyLeft + 'px' }
        : {};
    },
    isActive(url) {
      if (!url) return false;
      try {
        return window.location.pathname.indexOf(url.replace(/^https?:\/\/[^/]+/, '')) !== -1;
      } catch (e) {
        return false;
      }
    },
  },
  mounted() {
    this.$nextTick(function () {
      let body = $('body'),
          current = location.pathname,
          sidebar = $('.sidebar'),
          sidebarType = localStorage.getItem('sidebar');

      $(function () {
        // Add active class to nav-link based on url dynamically
        function addActiveClass(element) {
          if (element.attr('href').indexOf(current) !== -1) {
            element.parents('.nav-item').last().addClass('active');
            if (sidebarType === 'floating') {
              if (element.parents('.sub-menu').length) {
                element.closest('.collapse').removeClass('show');
                element.addClass('active');
              }
              if (element.parents('.submenu-item').length) {
                element.addClass('active');
              }
            } else {
              if (element.parents('.sub-menu').length) {
                element.closest('.collapse').addClass('show');
                element.addClass('active');
              }
              if (element.parents('.submenu-item').length) {
                element.addClass('active');
              }
            }
          }
        }

        $('.nav li a', sidebar).each(function () {
          let $this = $(this);
          addActiveClass($this);
        });

        $('.horizontal-menu .nav li a').each(function () {
          let $this = $(this);
          addActiveClass($this);
        });

        // Close other submenu in sidebar on opening any
        sidebar.on('show.bs.collapse', '.collapse', function () {
          sidebar.find('.collapse.show').collapse('hide');
        });

        // Change sidebar and content-wrapper height
        applyStyles();

        function applyStyles() {
          //Applying perfect scrollbar
          if (!body.hasClass("rtl")) {
            if (body.hasClass("sidebar-fixed")) {
              let fixedSidebarScroll = new PerfectScrollbar('#sidebar .nav');
            }
          }
        }
      });

      // Sidebar collapse menu on hover
      $(document).on('mouseenter mouseleave click', '.sidebar .nav-item', function (ev) {
        let body = $('body');
        let sidebarIconOnly = body.hasClass("sidebar-icon-only");
        let sidebarFixed = body.hasClass("sidebar-fixed");
        if (sidebarIconOnly) {
          if (sidebarFixed) {
            if (ev.type === 'mouseenter') {
              body.removeClass('sidebar-icon-only');
            }
          } else {
            let $menuItem = $(this);
            if (ev.type === 'mouseenter') {
              $menuItem.addClass('hover-open')
            } else if (ev.type === 'click') {
              $menuItem.addClass('hover-open')
            } else {
              $menuItem.removeClass('hover-open')
            }
          }
        }
      });

      // Close collapse menu when mouse leave from sidebar hover only
      $(document).on('mouseenter mouseleave', '.sidebar-hover-only .sidebar', function (ev) {
        if (ev.type === 'mouseleave') {
          $('.sidebar').find('.collapse.show').collapse('hide');
        } else {

        }
      });
    });
  }
}
</script>
